export default __webpack_public_path__ + "static/media/info_hover.34ed68ac.svg";